module.exports = __webpack_public_path__ + "img/sitting-woman.1d5248d2.png";